import { z } from "zod";
import type { AparenciaDoCatalogo } from "./aparencia-do-catalogo";

/** O catálogo do laboratório como se mostra pra fora: na visualização/PDF e no link público
 *  (/catalogo/<código>, o mesmo do QR da etiqueta). Só serviços oferecidos (ativos), uma linha
 *  por serviço e material (pedido do Jun: "Coroa anatômica Zircônia", "Coroa anatômica Dissilicato"). */
export type ServicoDoCatalogoPublico = {
  id: string;
  label: string;
  descricao: string | null;
  imagemUrl: string | null;
  abrangencia: "DENTE" | "ARCADA";
  linhas: {
    id: string;
    /** Nulo = serviço sem material compatível (uma linha só). */
    material: string | null;
    /** Centavos da tabela base (o do material, senão o geral do serviço); nulo = sem preço ou escondido. */
    precoCents: number | null;
  }[];
};

export type CatalogoDoLaboratorio = {
  laboratorio: {
    nome: string;
    logoUrl: string | null;
    cnpj: string | null;
    telefone: string | null;
    endereco: string | null;
  };
  comPreco: boolean;
  categorias: { categoria: string; servicos: ServicoDoCatalogoPublico[] }[];
  /** Sempre preenchida: a padrão quando o laboratório não personalizou ou não tem o plano. */
  aparencia: AparenciaDoCatalogo;
  capaUrl: string | null;
};

/** Código do link público: base64url, curto o bastante pro QR e longo o bastante pra não adivinhar. */
export const codigoDoCatalogoSchema = z.string().regex(/^[A-Za-z0-9_-]{12,32}$/);

export const configurarCatalogoPublicoSchema = z.object({
  /** Ligar gera um código; desligar apaga (o link e o QR antigos param de abrir). */
  ativo: z.boolean().optional(),
  comPreco: z.boolean().optional(),
  /** Troca o código: o link anterior para de funcionar. */
  novoCodigo: z.literal(true).optional(),
});
export type ConfigurarCatalogoPublicoInput = z.infer<typeof configurarCatalogoPublicoSchema>;

export function formatarPreco(cents: number): string {
  return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}
